import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import classNames from 'classnames';
import { checkValidLabel } from '../utils/accessibility.esm.js';
import '../utils/maskTypes.esm.js';
import { generateRandId } from '../utils/utils.esm.js';
import NvLabel from '../NvLabel/NvLabel.esm.js';

var NvCheckbox = React.forwardRef(function (_a, ref) {
    var _b;
    var id = _a.id, hideLabel = _a.hideLabel, label = _a.label, disabled = _a.disabled, className = _a.className, onChange = _a.onChange, _c = _a.size, size = _c === void 0 ? 'standard' : _c, checked = _a.checked, onBlur = _a.onBlur, inline = _a.inline, customLabel = _a.customLabel, title = _a.title, _d = _a.defaultChecked, defaultChecked = _d === void 0 ? false : _d, displayOnly = _a.displayOnly, hasError = _a.hasError, legendText = _a.legendText, onFocus = _a.onFocus, props = __rest(_a, ["id", "hideLabel", "label", "disabled", "className", "onChange", "size", "checked", "onBlur", "inline", "customLabel", "title", "defaultChecked", "displayOnly", "hasError", "legendText", "onFocus"]);
    var currentId = id || generateRandId().toString();
    var _e = __read(React.useState(defaultChecked), 2), isChecked = _e[0], setIsChecked = _e[1];
    checkValidLabel(label, currentId);
    var isCheckboxChecked = function () {
        if (displayOnly)
            return true;
        return checked === undefined ? isChecked : checked;
    };
    var toggle = function (event) {
        if (disabled || displayOnly)
            return;
        var checkedValue = isCheckboxChecked();
        var currentValue = typeof checkedValue === 'boolean' ? !checkedValue : true;
        setIsChecked(currentValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(currentValue, event, props === null || props === void 0 ? void 0 : props.value);
    };
    var handleBlur = function (event) {
        if (disabled || displayOnly)
            return;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    };
    var handleFocus = function (event) {
        if (disabled || displayOnly)
            return;
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    };
    var sizes = {
        small: 'nv-checkbox-size--small',
    };
    return (React.createElement("div", { className: classNames('nv-checkbox-wrapper', inline ? 'nv-checkbox-wrapper--inline' : 'nv-checkbox-wrapper--block', className), title: title },
        React.createElement("div", { className: classNames('nv-checkbox-input-wrapper', sizes === null || sizes === void 0 ? void 0 : sizes[size]) },
            React.createElement("div", { className: "nv-checkbox-content" },
                React.createElement("input", __assign({}, props, { "aria-checked": isCheckboxChecked(), "aria-disabled": !!disabled, "aria-label": label, "aria-readonly": displayOnly, className: classNames('nv-checkbox', {
                        'nv-checkbox--error': hasError,
                        'nv-checkbox-tick-mark': displayOnly,
                    }), id: currentId, onBlur: handleBlur, onChange: toggle, onFocus: handleFocus, ref: ref, tabIndex: 0, type: "checkbox" })),
                React.createElement("span", { className: "nv-checkbox-check" })),
            React.createElement(NvLabel, { className: classNames('nv-cursor-pointer', (_b = {}, _b['nv-cursor-default'] = displayOnly, _b)), htmlFor: currentId, isHidden: hideLabel || !!customLabel, value: label }),
            customLabel),
        legendText && (React.createElement("span", { className: classNames('nv-checkbox-legend nv-fine-print-1', { errorColor: hasError }) }, legendText))));
});
NvCheckbox.displayName = 'NvCheckbox';
var NvCheckbox$1 = React.memo(NvCheckbox);

export { NvCheckbox$1 as default };
//# sourceMappingURL=NvCheckbox.esm.js.map
